<template>
    <div>
        <div class="container-mob w-100 ">

            <buscador-component></buscador-component>

            <div v-if="!this.presupuesto_selected" class="elige-potencia pt-4">
                <h2 class="mb-4 ms-4">{{ presupuestos.length > 0 ? 'Elige un presupuesto:' : 'No hay presupuestos creados.' }}</h2>
                <div v-for="(presu, key) in presupuestos" class="enlace-potencia">
                    <div class=" d-flex justify-content-between" @click="selectPresupuesto(presu)">
                        <div>
                            <small>
                                <b>Estado:</b>
                                {{ presu.estado }}
                            </small>
                            <br>
                            <span class="ms-3">{{ presu.nombre_presupuesto }}</span>
                        </div>
                        <div>
                            <i class="fas fa-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="contenedor-presu">

                <div class="producto mt-4">
                    <div class="text-end" @click="goBack()">
                        <span class="color-red pe-3">
                            <i class="fas fa-chevron-left"></i>
                        </span>
                    </div>
                    <h3 class="mb-2" @click="focusInput('nombre_presu')"><i class="fas fa-pencil-alt"></i> Nombre su presupuesto</h3>
                    <input id="nombre_presu" class="mb-2 border-0" type="text" v-model="presupuesto.nombre_presupuesto">
                </div>
                <div class="text-end add-item">
                    <router-link :to="{ name: 'dashboard' }" style="color:red">Añadir item
                        <span class="color-red">+</span>
                    </router-link>
                </div>
                <div class="presupuesto-tabla mt-4">
                    <table class="tabla-presupuesto text-center">
                        <tr>
                            <td class="concepto">
                                <span class="">Concepto</span>
                            </td>
                            <td class="presupuesto-datos">
                                <span class="">Cantidad</span>
                            </td>
                            <td class="presupuesto-datos">
                                <span class="">Precio</span>
                            </td>
                        </tr>
                        <tr v-if="presupuesto.productos.length > 0" v-for="(producto, key) in presupuesto.productos">
                            <td class="text-start">
                                <i class="fas fa-trash color-red" @click="eliminarProducto(key)"></i>
                                <span class="dato-producto">{{ producto.nombre }}</span>
                                <br>
                                <span class="" @click="show_modal( 'descuento', producto)"><i class="fas fa-pencil-alt"></i> Descuento</span>
                            </td>
                            <td>
                                <div class="cantidad-presupuesto">
                                    <span @click="changeCantidad(producto, '-')">-</span>
                                    <span class="multiplicador-presupuesto">{{ producto.pivot.cantidad }}X</span>
                                    <span @click="changeCantidad(producto, '+')">+</span>
                                </div>
                                {{ producto.pivot.descuento }}%
                            </td>
                            <td>
                                <span class="color-black">{{ getPrecioDescuento(producto).toLocaleString("de-DE", { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }) }}</span>
                                <br>
                                <span class="tachado-rojo"><span>{{ getPrecioTotal(producto).toLocaleString("de-DE", { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }) }}</span></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start">
                                <span class="" @click="show_modal('coste')"><i class="fas fa-pencil-alt"></i> Coste de instalación aproximado</span>
                            </td>
                            <td>

                            </td>
                            <td>
                                <span class="">{{presupuesto.coste_instalacion}}€</span>
                            </td>
                        </tr>
                    </table>

                </div>

                <div class="container-mob w-100 datos-presupuesto">
                    <hr class="hr-presupuesto">
                    <div class="total-presupuesto text-end">
                        <span class="color-red">Total:</span>
                        <span>{{ getPrecioTotalPresupuesto().toLocaleString("de-DE", { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }) }}</span>
                    </div>
                    <div class="fechas-presupuesto">
                        <span>Fecha de creación:</span>
                        <br>
                        <span class="fecha-dato">{{ moment(presupuesto.created_at).format("DD.MM.YYYY") }}</span>
                        <hr class="hr-presupuesto">
                        <i class="fas fa-pencil-alt" @click="openPicker"></i>
                        <span>Vencimiento:</span>
                        <br>
                        <vuejs-datepicker ref="programaticOpen" input-class="border-0 fecha-dato fecha-texto " format="dd.MM.yyyy" :language="es" v-model="presupuesto.fecha_vencimiento"></vuejs-datepicker>
                    </div>

                </div>
            </div>
        </div>

        <div id="modal" class="modal" v-if="showModal" :class="showModal ? 'd-block' : ''">
            <!-- Modal content -->
            <div class="modal-content">
                <label class="descuento-label">Introduce el {{texto_modal}}:</label><input type="number" id="valor_modal" class="descuento-input" :min="accionModal==='descuento' ? 1:''" :max="accionModal==='descuento' ? 99:''">
                <button class="btn btn-danger btn-block mt-3" @click="valor_modal()">Aceptar</button>
            </div>

        </div>

        <div id="modal_eliminar_presupuesto" class="modal" v-if="showModalDelPresupuesto" :class="showModalDelPresupuesto ? 'd-block' : ''">
            <!-- Modal content -->
            <div class="modal-content text-center">
                <h2>¿Estás seguro que deseas eliminar el presupuesto?</h2>
                <div>
                    <button class="btn btn-secondary btn-block mt-3" @click="showModalDelPresupuesto = false;">Regresar</button>
                    <button class="btn btn-danger btn-block mt-3 mx-2" @click="eliminarPresupuesto()">Eliminar</button>
                </div>
            </div>

        </div>

        <div class="botones-producto d-flex justify-content-between" v-if="this.presupuesto_selected">
            <button class="btn btn-red" @click="descargarPresupuesto()" :disabled="status_descarga !== 'disponible'">
                Descargar presupuesto
            </button>
            <button class="btn btn-red mx-4" @click="showModalDelPresupuesto = true;">
                Eliminar presupuesto
            </button>
            <button class="btn btn-green" @click="guardarPresupuesto()">
                Guardar
            </button>
        </div>
        <div class="modal-spinner" v-show="status_descarga==='descargando'">
            <spinner size="80px"></spinner>
        </div>
        <menu-component></menu-component>
    </div>
</template>

<script>
import {es} from 'vuejs-datepicker/dist/locale'

export default {
    data() {
        return {
            presupuesto_selected: false,
            presupuestos: [],
            presupuesto: null,
            es: es,
            texto_modal: '',
            showModal: false,
            showModalDelPresupuesto:false,
            productoModal : null,
            accionModal : null,
            status_descarga: 'disponible'
        };
    },
    methods: {
        selectPresupuesto(presu) {
            this.$store
            .dispatch("editPresupuesto",{
                presupuesto : presu
            })
            .then(response => {
                this.presupuesto_selected = true;
                this.presupuesto = presu;
            })
            .catch(error => {
                this.errors = error.response.data;
            });

        },
        goBack() {
            this.presupuesto_selected = false;
            this.presupuesto = null;
        },
        getPrecioTotalPresupuesto: function () {
            var that = this;
            let total = 0;
            this.presupuesto.productos.forEach(function(producto) {
                total += that.getPrecioDescuento(producto);
            });
            total += this.presupuesto.coste_instalacion;
            return total;
        },
        getPrecioDescuento: function (producto) {
            return producto.pivot.descuento > 0 ? producto.precio * producto.pivot.cantidad - ((producto.precio * producto.pivot.cantidad) * (producto.pivot.descuento / 100)) : producto.precio * producto.pivot.cantidad;
        },
        getPrecioTotal: function (producto) {
            return (producto.precio * producto.pivot.cantidad);
        },
        changeCantidad: function (producto, operacion) {
            if(operacion === '-'){
                producto.pivot.cantidad = producto.pivot.cantidad > 1 ? producto.pivot.cantidad - 1 : 1;
            }else{
                producto.pivot.cantidad = producto.pivot.cantidad + 1;
            }
        },
        guardarPresupuesto: function () {
            var that = this;
            this.$store
            .dispatch("savePresupuesto",{
                presupuesto : this.presupuesto
            })
            .then(response => {
                that.$notify({
                    group: 'not',
                    type: 'success',
                    title: 'Presupuesto guardado correctamente.',
                });
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        eliminarPresupuesto: function () {
            var that = this;
            this.$store
            .dispatch("deletePresupuesto",{
                presupuesto : this.presupuesto
            })
            .then(response => {
                that.$notify({
                    group: 'not',
                    type: 'success',
                    title: 'Presupuesto eliminado correctamente.',
                });
                that.showModalDelPresupuesto = false;
                window.location.reload()
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        descargarPresupuesto: function () {

            this.status_descarga = 'descargando';

            var that = this;
            this.$store
            .dispatch("savePresupuesto",{
                presupuesto : this.presupuesto
            })
            .then(response => {
                this.$store
                .dispatch("downloadPresupuesto",{
                    presupuesto : this.presupuesto
                })
                .then(response => {

                    that.status_descarga = 'disponible';
                    that.$notify({
                        group: 'not',
                        type: 'success',
                        title: 'Presupuesto descargado correctamente.',
                    });

                    gtag('event', 'Descarga_Presupuesto');
                })
                .catch(error => {
                    this.errors = error.response.data;
                });
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        focusInput(campo) {
            document.getElementById(campo).focus();
        },
        eliminarProducto(index){
            this.presupuesto.productos.splice(index, 1);
        },
        show_modal(accion, producto=null){
            if(accion ==='descuento'){
                this.texto_modal = ' % de descuento';
                this.productoModal = producto;
            }else{
                this.texto_modal = 'coste de instalación';
            }
                this.accionModal = accion;
                this.showModal = true;
        },
        valor_modal(){
            let valor = parseFloat(document.getElementById("valor_modal").value);
            if(this.accionModal === 'descuento'){
                if(valor > 99){
                    valor = 99;
                }else if(valor < 0 || isNaN(valor)){
                    valor = 0;
                }
                this.productoModal.pivot.descuento =valor;
            }else{
                if(valor < 0 || isNaN(valor)){
                    valor = 0;
                }
                this.presupuesto.coste_instalacion = valor;
            }
            this.accionModal = null;
            this.texto_modal = '';
            this.showModal = false;
        }
    },
    mounted: function () {
        this.$store
        .dispatch("getPresupuestos")
        .then(response => {
            var that = this;
            this.presupuestos = response.data;

            this.presupuestos.forEach(function(presupuesto) {
                if(presupuesto.estado === 'Borrador'){
                    that.presupuesto_selected = true;
                    that.presupuesto = presupuesto;
                }
            });
        })
        .catch(error => {
            console.log(error);
        });
    },
    computed: {
        // a computed getter

    }
};
</script>

<style>
.vdp-datepicker__calendar{
    bottom: 100%;
}
.fecha-texto {
    color: #989898 !important;
}
.contenedor-presu{
    overflow-y: scroll;
    height: calc(100vh - 250px);
}
.spinner--mikepad{
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
}
.spinner-inner .pad{
    border-color: red !important;
}
.spinner-inner .binding{
    border-color: red !important;
}
.spinner-inner .line{
    border-color: white !important;
}
.modal-spinner{
    display: block;
    position: fixed;
    z-index: 999999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
